import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DIETARY_LABELS } from '../../../../core/utils/catering';

@Component({
  selector: 'ct-dietary-badges',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (tag of tags(); track tag) {
      @if (getLabel(tag); as label) {
        <span class="db" [style.--badge-color]="label.colour">{{ label.short }}</span>
      }
    }
  `,
  styles: [`
    :host { display: inline-flex; gap: 3px; }
    .db {
      font-size: 10px; /* type-scale floor */
      font-weight: 700;
      padding: 1px 5px;
      border-radius: 100px;
      background: color-mix(in srgb, var(--badge-color) 15%, transparent);
      color: var(--badge-color);
      line-height: 1.4;
    }
  `],
})
export class DietaryBadgesComponent {
  readonly tags = input.required<string[]>();

  protected getLabel(tag: string): { short: string; label: string; colour: string } | null {
    return DIETARY_LABELS[tag] ?? null;
  }
}
